// docs: https://github.com/altostra/type-validations#readme
import { objectOf, enumOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isCommentsNotificationSettingResult = objectOf({
  is_creator: boolean,
  is_globally_opted_out: boolean,
  explicit_setting: enumOf("all", "targeted", "none", null),
});
